<template>
  <dc-layout-main>
    <dc-layout-content>
      <cos-table serial :columns="columns" @fetch="fetch" v-model:search="queryForm" ref="tableRef" tableId="DcCosLossCustomer">
        <template #search>
          <a-form :model="queryForm">
            <dc-form-item name="customerName" label="客户名称">
              <a-input v-model:value="queryForm.customerName" allowClear placeholder="请输入" />
            </dc-form-item>
            <dc-form-item name="customerNumber" label="主客户代码">
              <a-input v-model:value="queryForm.customerNumber" allowClear placeholder="请输入" />
            </dc-form-item>
          </a-form>
        </template>
        <template #bodyCell="{ column, record }">
          <template v-if="column.dataIndex === 'arkCode'">
            <span>{{record.arkCode.join(",")}}</span>
          </template>
          <template v-if="column.dataIndex === 'action'">
            <more-button>
              <a-button type="link" @click="deleteRow(record)" v-permission="'fbu_losscus_delete_btn'">删除</a-button>
            </more-button>
          </template>
        </template>
        <template #button>
          <a-button type="primary" @click="addEdit()" v-permission="'fbu_losscus_add_btn'">新增</a-button>
        </template>
      </cos-table>
      <editModal ref="editModalRef" @success="success" />
    </dc-layout-content>
  </dc-layout-main>
</template>
<script lang="ts">
import editModal from './components/editModal.vue'
import Modal from '@/hooks/modalType'
import { reactive, ref, computed } from 'vue'
import { customerLossList, customerLossDelete } from '@/api/gucangSales/businessRuleSetting'

import { DcMessage } from '@dc-platform/dc-components'
import { BigScoreBakcData } from '@/typings/api/gucangSale'
export default { name: 'DcCosFbuLossCustomer' }
</script>
<script setup lang="ts">
const editModalRef = ref<{toggle :(row?: BigScoreBakcData) => void}>()

const tableRef = ref()
const queryForm = reactive({
  arkCode: '',
  customerName: ''
})

// 获取列表
const fetch = async(params: object, callBack: (res: any) => void) => {
  const res = await customerLossList({ ...params })
  callBack(res)
}
const success = () => {
  tableRef.value.fetch()
}
const columns = computed(() => [
  { title: '客户名称', dataIndex: 'customerName' },
  { title: '主客户代码', dataIndex: 'customerNumber' },
  {
    title: '操作',
    dataIndex: 'action',
    fixed: 'right'
  }
])
const addEdit = (_row?: BigScoreBakcData) => {
  editModalRef.value?.toggle(_row)
}
const deleteRow = (row: BigScoreBakcData) => {
  Modal.delete({
    name: row.customerName,
    onOk() {
      customerLossDelete({ cosId: row.cosId }).then(() => {
        DcMessage.success('删除成功')
        tableRef.value?.delFetch()
        success()
      })
    }
  })
}
</script>

<style scoped></style>
